
<template>
  <v-app id="onKstp">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{kstp.kstp_nr}}    <!-- <v-btn text @click="kstpView()">View</v-btn> <br> -->

      <span v-for="(kstptaalRecord,i) in kstp.kstptaal" :key="i">
       <br>
       {{kstptaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveKstptaal(kstptaalRecord)">Save</v-btn><br>
       <v-textarea v-model="kstptaalRecord.kstptaal_oms" :value=kstptaalRecord.kstptaal_oms rows="2" label="Print text"></v-textarea>
       <br>
         <span v-for="(ktpztaalRecord,j) in kstptaalRecord.ktpz" :key="j">
          <br>
          {{ktpztaalRecord.ktpz_nr}}  <v-btn class="primary ma-2" small @click="saveKtpztaal(ktpztaalRecord)">Save</v-btn><br>
          <v-textarea v-model="ktpztaalRecord.ktpztaal_oms" :value=ktpztaalRecord.ktpztaal_oms rows="2" label="Print text"></v-textarea>
       <br>
      </span>  
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['kstp_encrid'],
  data() {
    return {
      kstp: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/kstp/getKstp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKstp"
          },
          getKstp: {
             kstp_encrid: this.kstp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.kstp = res.data.getKstp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveKstptaal(kstptaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/kstp/saveKstptaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveKstptaal"
          },
          saveKstptaal: {
            kstptaal: kstptaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveKstptaal.text,
              color: res.data.saveKstptaal.color
            });
          }
        })
    },
    saveKtpztaal(ktpztaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/kstp/saveKtpztaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveKtpztaal"
          },
          saveKtpztaal: {
            ktpztaal: ktpztaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveKtpztaal.text,
              color: res.data.saveKtpztaal.color
            });
          }
        })
    }
  }  

};

</script> 
